import { createFeature, createReducer, on } from '@ngrx/store';
import { EmptyAddress } from 'clicklease-ui-elements';
import { PersonalInformationState } from './../../interfaces/personal-information';
import {
    LoadPersonalInfoAction,
    ResetPersonalInfoAction,
    SetPersonalInfoAction,
} from './personal-information.actions';

const initialState: PersonalInformationState = {
    isLoaded: false,
    data: {
        id: '',
        roseId: '',
        email: '',
        firstName: '',
        lastName: '',
        phone: '',
        address: EmptyAddress(),
        lastModifiedDate: null,
    },
};

export const PersonalInfoFeatureName = 'PersonalInformation';

export const PersonalInfoFeature = createFeature({
    name: PersonalInfoFeatureName,
    reducer: createReducer(
        initialState,
        on(LoadPersonalInfoAction, (state) => state),
        on(
            SetPersonalInfoAction,
            (state, {
                id,
                roseId,
                email,
                firstName,
                lastName,
                phone,
                address,
                lastModifiedDate,
            }) => ({
                ...state,
                data: {
                    id,
                    roseId,
                    email,
                    firstName,
                    lastName,
                    phone,
                    address,
                    lastModifiedDate,
                },
                isLoaded: true,
            })
        ),
        on(ResetPersonalInfoAction, () =>
            initialState
        )
    ),
});